var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8.571,
    fill: "url(#instagram_svg__paint0_radial_11108_10173)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8.571,
    fill: "url(#instagram_svg__paint1_radial_11108_10173)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8.571,
    fill: "url(#instagram_svg__paint2_radial_11108_10173)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 12.143a2.143 2.143 0 11-4.286 0 2.143 2.143 0 014.286 0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 27.143a7.143 7.143 0 100-14.286 7.143 7.143 0 000 14.286zm0-2.857a4.286 4.286 0 100-8.572 4.286 4.286 0 000 8.572z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.214 19.429c0-4.8 0-7.201.934-9.035a8.572 8.572 0 013.746-3.745c1.833-.935 4.234-.935 9.034-.935h1.143c4.8 0 7.2 0 9.034.935a8.572 8.572 0 013.746 3.745c.934 1.834.934 4.234.934 9.035v1.143c0 4.8 0 7.2-.934 9.034a8.572 8.572 0 01-3.746 3.746c-1.833.934-4.233.934-9.034.934h-1.143c-4.8 0-7.2 0-9.034-.934a8.572 8.572 0 01-3.746-3.746c-.934-1.834-.934-4.234-.934-9.035V19.43zM19.928 8.572h1.143c2.447 0 4.111.002 5.397.107 1.253.102 1.893.288 2.34.515a5.714 5.714 0 012.497 2.498c.228.446.413 1.087.516 2.34.105 1.286.107 2.95.107 5.397v1.143c0 2.447-.002 4.11-.107 5.396-.103 1.253-.288 1.894-.516 2.34a5.714 5.714 0 01-2.497 2.498c-.447.227-1.087.413-2.34.515-1.286.105-2.95.108-5.397.108h-1.143c-2.447 0-4.11-.003-5.397-.108-1.253-.102-1.893-.288-2.34-.515a5.714 5.714 0 01-2.497-2.497c-.228-.447-.413-1.088-.516-2.34-.105-1.286-.107-2.95-.107-5.398V19.43c0-2.448.002-4.111.107-5.397.103-1.253.288-1.894.516-2.34a5.714 5.714 0 012.497-2.498c.447-.227 1.087-.413 2.34-.515 1.286-.105 2.95-.107 5.397-.107z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__paint0_radial_11108_10173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-55.376 35.978 .911) scale(36.4566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__paint1_radial_11108_10173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-65.136 39.108 10.259) scale(32.2775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram_svg__paint2_radial_11108_10173",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-8.13 9.23 12.273) scale(55.5584 11.8834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.468,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}

export default SvgInstagram;